import createCache from '@emotion/cache';

// The server injects a per-request CSP nonce into index.html as
// <meta property="csp-nonce" content="..."> (Django's {{ csp_nonce }}). Reading
// it here and handing it to Emotion stamps every runtime <style> tag with the
// nonce, so MUI styling works under a strict style-src without 'unsafe-inline'.
const meta = document.querySelector('meta[property="csp-nonce"]');
const raw = meta ? meta.getAttribute('content') : null;
// In the CRA dev server the template isn't rendered, so the placeholder is left
// literal — ignore it (no CSP is enforced in dev anyway).
const nonce = raw && !raw.includes('{{') ? raw : undefined;

// prepend: true keeps MUI styles first in <head> so app styles can override them.
const emotionCache = createCache({ key: 'css', nonce, prepend: true });

export default emotionCache;
